import React from "react";
import AutoSearchInput from "utilFunctions/shared/AutoSearchInput";
// import CustomSelect from "Components/CommonComponents/CustomSelect";
import Typography from "Components/CommonComponents/Typography";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import "./PerformanceSearchBar.css";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { useEffect } from "react";
import { useState, useContext } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
// import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import { UserInfoContext } from "Context/CommonContext";
import { CustomDropdownWithSelect } from "Components/CommonComponents/CustomDropdownWithSelect";
import { BASE_URL, STUDENT_SEARCH } from "utilFunctions/Constants/urlConstants";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import { CORPORATE_BRANCH_CODE } from "utilFunctions/Constants/Constants";
import LeftArrow from "Assets/Icons/LeftArrow";
import useMasterContext from "Context/MasterContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import FilterIcon from "Assets/Icons/FilterIcon";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import useGlobalSearchContext from "Context/GlobalSearchContext";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
export interface selectInterface {
  label: any;
  key: any;
  value: any;
  region?: any;
  regionCode?: any;
  id?: any;
}
const ColStyled = styled<any>(Col)`
  display: flex;
  margin-left: 0px;
  flex-direction: ${(props: any) =>
    ["xl", "xxl"].includes(props.screen) ? "row" : "column"};
  padding-right: 0px;
  padding-left: 0px;
  justify-content: end;
`;
const CardBodyStyled = styled<any>(CardBody)`
  padding: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "12px 16px" : "12px"};
`;
export const nullOption = [{ label: "All", key: "all", value: null }];
type IPerformanceSearchBar = {
  mode?: string;
  viewAllComments?: boolean;
  isPerformanceVisible?: boolean;
  setIsPerformanceVisible?: any;
};
const PerformanceSearchBar = ({
  mode,
  isPerformanceVisible,
  setIsPerformanceVisible,
}: IPerformanceSearchBar) => {
  const navigate = useNavigate();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { saveGlobalSearchData } = useGlobalSearchContext();
  const { masters } = useMasterContext();
  const { screen }: any = useWindowSize();
  const [stream, setStream] = useState<selectInterface[]>(
    masters?.streams ? nullOption.concat(masters.streams) : []
  );
  const [classes, setClassess] = useState<selectInterface[]>(
    masters?.classes ? nullOption.concat(masters.classes) : []
  );
  const [filterState, setFilterState] = useState<any>({
    stream: null,
    clazz: null,
    branch: null,
  });
  const [branches, setBranches] = useState<selectInterface[]>([]);
  const [searchName, setSearchName] = useState<any>();
  const [inputValue, setInputValue] = useState<any>();
  const [suggestions, setSuggestions] = useState<any>([]);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [limit] = useState<number>(10);
  const [offset, setOffSet] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [searchURL, setSearchURL] = useState<string>("");
  const [isPaneOpen, setisPaneOpen] = useState<boolean>(false);
  const [input, setInput] = useState("");
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Stream",
      nickName: "stream",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Class",
      nickName: "clazz",
      data: classes,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Branch",
      nickName: "branch",
      data: branches,
      singleSelect: false,
      filterSelectedData: [],
    },
  ]);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Stream",
        nickName: "stream",
        data: masters?.streams,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Class",
        nickName: "clazz",
        data: masters?.classes,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Branch",
        nickName: "branch",
        data: nullOption.concat(masters?.userAssignedBranches),
        singleSelect: false,
        filterSelectedData: [],
      },
    ]);
  }, [masters?.streams, masters?.classes, masters?.userAssignedBranches]);
  useEffect(() => {
    setStream(nullOption.concat(userInfo?.userStreams as any));
  }, [userInfo, masters?.streams]);
  useEffect(() => {
    setClassess(nullOption.concat(masters?.classes));
  }, [masters?.classes]);
  useEffect(() => {
    setBranches(masters?.userAssignedBranches);
  }, [masters?.userAssignedBranches]);

  const { makeRequest: GetSearchData, responseData: searchData } = useGetApi(
    (data) => {
      onFetcheddata(data);
    },
    (error) => {
      onFetchError(error);
    }
  );
  const onFetcheddata = (data: any) => {
    setIsLoader(false);
    console.log(data);
  };
  const onFetchError = (error: any) => {
    console.log("erorr", error);
    setIsLoader(false);
    if (offset == 0) {
      // setSuggestions([]);
    } else {
      setOffSet(0);
    }
    setHasMore(false);
  };

  useEffect(() => {
    if (searchData && searchData != null) {
      if (offset == 0) {
        setSuggestions([...searchData["data"]]);
      } else {
        setSuggestions((previous: any) => [...previous, ...searchData["data"]]);
      }
      setHasMore(
        searchData["data"] && searchData["data"].length > 0 ? true : false
      );
    }
  }, [searchData]);
  const handleAddFilterArrayList = (name: string, val: any) => {
    setOffSet(0);
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
    if (inputValue != "" && inputValue != undefined) {
      searchDataHandler(inputValue, val, name);
    }
  };
  const removeNullValues = (filterState: any) => {
    const formObj: any = {};
    Object.keys(filterState).map((ele: any) => {
      if (filterState[ele]) {
        if (ele == "branch") {
          formObj[ele] = filterState[ele]
            .map((ele: any) => ele.value)
            .filter((el: any) => el != "");
        } else {
          formObj[ele] = filterState[ele].value;
        }
      }
    });
    return formObj;
  };
  const hasNumbers = (t: any) => {
    const regex = /\d/g;
    return regex.test(t);
  };
  const userBranchArray: any = userInfo.branch.split(",").map(Number);
  const returnBranchCode = (branches: any) => {
    const arr = branches.map((ele: any) => {
      return ele["value"].substring(ele["value"].length - 3);
    });
    return arr.toString();
  };
  const searchDataHandler = (searchterm: any, value?: any, keyName?: any) => {
    let url = `${BASE_URL + STUDENT_SEARCH}`;
    // REMOVE NULL values from filterState
    const formValues: any = removeNullValues(filterState);
    // REMOVE KEY FROM formValues if no value exits
    if (value == null) {
      delete formValues[keyName];
    }

    // CHECK IF VALUE IS NOT EXITS in formValues and add in it
    if (value != undefined && formValues[keyName] == undefined) {
      formValues[keyName] = value?.value;
    }

    //IF VALUE IS EXITS  in formValues THEN UPDATE IT
    if (formValues[keyName] != undefined) {
      if (keyName == "branch") {
        formValues[keyName] = value
          ?.map((ele: any) => ele.value)
          .filter((el: any) => el != "");
      } else {
        formValues[keyName] = value?.value;
      }
    }
    if (value?.value == null || formValues[keyName] == null) {
      if (keyName != "branch") {
        delete formValues[keyName];
      }
    }
    const result = [];
    for (const key in formValues) {
      if (formValues[key] != null) {
        result.push(
          encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
        );
      }
    }
    if (hasNumbers(searchterm)) {
      if (result.length > 0) {
        url = url + `psid=${searchterm}&` + result.join("&");
      } else {
        url = url + `psid=${searchterm}`;
      }
    } else {
      if (result.length > 0) {
        url = url + `name=${searchterm}&` + result.join("&");
      } else {
        url = url + `name=${searchterm}`;
      }
    }
    const isBranchInFilter = formValues["branch"];
    if (
      isBranchInFilter == undefined &&
      !userBranchArray.includes(CORPORATE_BRANCH_CODE)
    ) {
      url = url + "&branch=" + returnBranchCode(masters?.userAssignedBranches);
    }
    // url = url + "stream=SOF&branch=040";
    setSearchURL(url);
    GetSearchData(url);
  };
  const handleSetInputValue = (val: string) => {
    setInputValue(val);
    setOffSet(0);
  };
  const nextHandler = () => {
    const newOffset = offset + limit;
    setOffSet((previous) => previous + limit);
    const url = searchURL + "&limit=" + limit + "&offset=" + newOffset;
    GetSearchData(url);
  };
  const applyFilterHandler = () => {
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      obj[ele.nickName] = ele.singleSelect
        ? ele.filterSelectedData[0]
        : ele.filterSelectedData;
    });
    setFilterState(obj);
  };
  const handleClearAllFilter = () => {
    const clearedFilter = {
      stream: null,
      clazz: null,
      branch: null,
    };
    setFilterState(clearedFilter);
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return { ...ele, filterSelectedData: [] };
      }
    );
    setfilterheadingListing(filterheadingListingArr);
  };
  const toggltePerformanceVisible = () => {
    setIsPerformanceVisible(!isPerformanceVisible);
  };
  const isBranchDisabled = userBranchArray.includes(CORPORATE_BRANCH_CODE)
    ? false
    : true;
  const filterLength = Object.values(filterState).filter(
    (ele) => ele != null
  ).length;
  return (
    <Card
      style={{
        width: "100%",
        marginBottom: "0px",
      }}
    >
      {["xs", "sm", "md"].includes(screen) && (
        <FilterSliderComponent
          width={"100%"}
          isPaneOpen={isPaneOpen}
          setisPaneOpen={setisPaneOpen}
          hideHeader={true}
          filterheadingListing={
            isBranchDisabled
              ? filterheadingListing.filter((ele) => ele.name != "Branch")
              : filterheadingListing
          }
          setfilterheadingListing={setfilterheadingListing}
          applyFilterHandler={applyFilterHandler}
        ></FilterSliderComponent>
      )}
      <CardBodyStyled screen={screen}>
        <CardTitle
          tag="h5"
          className={
            mode == "miniPerformance"
              ? "titleBar mb-0 cursor-pointer"
              : "titleBar mb-0"
          }
          onClick={() => {
            mode == "miniPerformance" && toggltePerformanceVisible();
          }}
        >
          {!["xs", "sm", "md"].includes(screen) && (
            <Row className="rowMain d-flex align-items-center">
              <Col
                xxl="4"
                xl="4"
                lg="4"
                md="4"
                sm="6"
                xs="6"
                className="d-flex flex-row p-0 align-items-center"
              >
                {mode &&
                  (mode == "performance" || mode == "mobilePerformance") && (
                    <LeftArrow
                      className={"cursorHoverCSS mr-3"}
                      onClick={() => {
                        if (mode == "mobilePerformance") {
                          saveGlobalSearchData({
                            pathurl: null,
                            isBranchHealth: false,
                            isStudentHealth: false,
                            isPerformance: false,
                          });
                        } else {
                          if (
                            userInfo?.fexRole == UserRoles?.academicCounsellor
                          ) {
                            navigate("/admin/myBranch", {
                              replace: true,
                              state: {
                                selectedStudent: null,
                              },
                            });
                          } else {
                            navigate("/admin/dashboard", {
                              replace: true,
                              state: {
                                selectedStudent: null,
                              },
                            });
                          }
                        }
                      }}
                    />
                  )}
                <Typography
                  variant={
                    mode == "miniPerformance"
                      ? "h6"
                      : ["xxl", "xl", "lg"].includes(screen)
                      ? "h6F"
                      : "h6"
                  }
                  color="black"
                >
                  Search student
                </Typography>
              </Col>
              {["xxl", "xl", "lg"].includes(screen) ? (
                <ColStyled
                  screen={screen}
                  xxl="8"
                  xl="8"
                  lg="8"
                  md="8"
                  sm="6"
                  xs="6"
                >
                  {mode != "miniPerformance" ? (
                    <>
                      <Row className="w-100 d-flex justify-content-end">
                        <Col
                          xxl="2"
                          xl="2"
                          lg="2"
                          md="12"
                          sm="12"
                          xs="12"
                          className="d-flex justify-content-end"
                        >
                          <Typography variant="h4" color="black">
                            Filter
                          </Typography>
                        </Col>
                        <Col xxl="2" xl="2" lg="2" md="12" sm="12" xs="12">
                          <CustomSelect
                            isSelected={
                              filterState.stream != null ? true : false
                            }
                            width={"100%"}
                            top={"-3px"}
                            placeholder="Stream"
                            options={stream}
                            isSearchable={false}
                            menuPlacement="bottom"
                            isClearable={false}
                            menuShouldScrollIntoView={true}
                            closeMenuOnSelect={true}
                            onChange={(selected: any) => {
                              handleAddFilterArrayList("stream", selected);
                            }}
                            value={filterState.stream}
                          />
                        </Col>
                        <Col
                          xxl="2"
                          xl="2"
                          lg="2"
                          md="12"
                          sm="12"
                          xs="12"
                          className={
                            ["xxl", "xl"].includes(screen) ? "" : "mt-2"
                          }
                        >
                          <CustomSelect
                            isSelected={
                              filterState.clazz != null ? true : false
                            }
                            width={"100%"}
                            top={"-3px"}
                            placeholder="Class"
                            options={classes}
                            isSearchable={false}
                            menuPlacement="bottom"
                            isClearable={false}
                            menuShouldScrollIntoView={true}
                            closeMenuOnSelect={true}
                            onChange={(selected: any) => {
                              handleAddFilterArrayList("clazz", selected);
                            }}
                            value={filterState.class}
                          />
                        </Col>
                        <Col
                          xxl="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                          xs="12"
                          className={
                            ["xxl", "xl", "lg"].includes(screen)
                              ? "d-flex"
                              : "mt-2"
                          }
                        >
                          <CustomDropdownWithSelect
                            isSelected={false}
                            placeholderLabel="Branch"
                            width={"100%"}
                            isInPerformance={true}
                            options={branches}
                            menuPlacement="bottom"
                            isClearable={false}
                            isSearchable={true}
                            isMulti={true}
                            isSearchableDrop={true}
                            isDropdownSelect={true}
                            top={"0px"}
                            isDisabled={isBranchDisabled}
                            menuShouldScrollIntoView={true}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            onChange={(selected: any) => {
                              handleAddFilterArrayList("branch", selected);
                            }}
                            showClearIcon={
                              userBranchArray.includes(CORPORATE_BRANCH_CODE)
                                ? false
                                : false
                            }
                            value={filterState.branch}
                          />
                          {isPerformanceVisible &&
                            location.pathname.split("/")[
                              location.pathname.split("/").length - 1
                            ] != "performance" && (
                              <div
                                className="d-flex align-items-center"
                                onClick={toggltePerformanceVisible}
                              >
                                <span className="filterSpan pl-2">Close</span>
                              </div>
                            )}
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <div
                      className="d-flex align-items-center"
                      onClick={toggltePerformanceVisible}
                    >
                      <span className="filterSpan">Filter</span>
                      <FilterIcon className="cursor-pointer" />
                    </div>
                  )}
                </ColStyled>
              ) : (
                <Col
                  xxl="8"
                  xl="8"
                  lg="8"
                  md="8"
                  sm="6"
                  xs="6"
                  className="d-flex justify-content-end p-0"
                >
                  {filterLength != 0 ? (
                    <div className="d-flex">
                      <div
                        className="clearAllButtonStyle cursorHoverCSS"
                        onClick={() => {
                          handleClearAllFilter();
                        }}
                      >
                        Clear all
                      </div>
                      <FilterIcon
                        onClick={() => {
                          setisPaneOpen(!isPaneOpen);
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      className="d-flex align-items-center"
                      onClick={() => {
                        setisPaneOpen(!isPaneOpen);
                      }}
                    >
                      <span className="filterSpan">Filter</span>
                      <FilterIcon />
                    </div>
                  )}
                  {filterLength != 0 ? (
                    <div className="filterButtonTipMB">{filterLength}</div>
                  ) : null}
                </Col>
              )}
            </Row>
          )}
          <Row>
            <Col md="12">
              <Row>
                <Col
                  md={["xs", "sm", "md"].includes(screen) ? "10" : "12"}
                  lg={["xs", "sm", "md"].includes(screen) ? "10" : "12"}
                  xl={["xs", "sm", "md"].includes(screen) ? "10" : "12"}
                  sm={["xs", "sm", "md"].includes(screen) ? "10" : "12"}
                  xs={["xs", "sm", "md"].includes(screen) ? "10" : "12"}
                  className={["xs", "sm", "md"].includes(screen) ? "pr-0" : ""}
                >
                  <AutoSearchInput
                    setInputValue={(val: string) => handleSetInputValue(val)}
                    setSuggestions={setSuggestions}
                    suggestions={suggestions}
                    isLoader={isLoader}
                    setIsLoader={setIsLoader}
                    searchData={searchDataHandler}
                    searchName={searchName}
                    setSearchName={setSearchName}
                    placeholder="Search by student name or PSID"
                    nextHandler={nextHandler}
                    hasMore={hasMore}
                    input={input}
                    setInput={setInput}
                  />
                </Col>
                {["xs", "sm", "md"].includes(screen) && (
                  <Col
                    md="2"
                    lg="2"
                    xl="2"
                    sm="2"
                    xs="2"
                    className="d-flex justify-content-center"
                    onClick={() => {
                      setisPaneOpen(!isPaneOpen);
                    }}
                  >
                    <FilterIcon />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </CardTitle>
      </CardBodyStyled>
    </Card>
  );
};
export default PerformanceSearchBar;
